import { useState, useEffect } from 'react'
import LanguageSelector from './LanguageSelector'
import { Logo } from './Logo'
import { isLanguage, languageHref, resolveInitialLanguage } from '../lib/language'

// Privacy 는 회사 사이트(cottonray.com/privacy/<서비스>)로 이관했으므로 외부 링크.
const PRIVACY_URL = 'https://cottonray.com/privacy/easy-air-screen'
const SUPPORT_URL = 'https://cottonray.com/support/easy-air-screen'

export function Navbar() {
  const [currentLang, setCurrentLang] = useState<string>(resolveInitialLanguage)
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  const handleLanguageChange = (lang: string) => {
    setCurrentLang(lang)
    localStorage.setItem('language', lang)
    // 주소도 같이 옮긴다 — 새로고침·공유·뒤로가기가 그 언어를 기억하고, 검색엔진이 색인한
    // 주소와 사람이 보는 화면이 어긋나지 않는다. 페이지는 다시 부르지 않는다.
    if (isLanguage(lang)) window.history.replaceState(null, '', languageHref(lang))
    window.dispatchEvent(new CustomEvent('languagechange', { detail: lang }))
  }

  return (
    <header className="border-hair border-b">
      {/* 좁은 화면에서 헤더가 뷰포트보다 넓어지면 페이지 전체가 가로로 밀린다 —
          로고·간격을 줄이고 그래도 모자라면 줄바꿈으로 흘린다. */}
      <nav className="mx-auto flex max-w-5xl flex-wrap items-center justify-between gap-x-3 gap-y-2 px-5 py-4 sm:px-6">
        <a href="/" className="shrink-0" aria-label="Easy Air Screen">
          <Logo className="h-6 w-auto sm:h-7" />
        </a>
        <div className="flex min-w-0 flex-wrap items-center justify-end gap-0.5 sm:gap-2">
          {[
            { href: SUPPORT_URL, name: 'Support' },
            { href: PRIVACY_URL, name: 'Privacy' },
          ].map(({ href, name }) => (
            <a
              key={href}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-ink-mut hover:text-ink rounded-md px-1.5 py-1 text-sm transition-colors sm:px-2"
            >
              {name}
            </a>
          ))}
          {mounted && (
            <LanguageSelector currentLang={currentLang} onLanguageChange={handleLanguageChange} />
          )}
        </div>
      </nav>
    </header>
  )
}
